<template>
<div
    class="q-pa-lg"
    style="width: 100%; max-width: 1200px"
>
    <q-drawer
      v-model="drawer"
      show-if-above
      :width="200"
      :breakpoint="200"
      class="bg-grey-3"
    >
      <q-list
        padding
        class="menu-list text-left"
      >
      <q-item v-ripple>
          <q-item-section>
            <q-select
              v-model="sessionIdSelected"
              @update:model-value="onSelectedSessionUpdate(sessionIdSelected)"
              :options="activeStudentSession"
              label="Session"
              placeholder="Select a session"
              emit-value
              map-options
            />
          </q-item-section>
        </q-item>
        <q-item
          clickable
          v-ripple
          @click="activeNavItem = 'summary'"
          :active="activeNavItem === 'summary'"
        >
          <q-item-section avatar>
            <q-icon name="home" />
          </q-item-section>

          <q-item-section>
            Summary
          </q-item-section>
        </q-item>

        <q-item
          clickable
          v-ripple
          @click="activeNavItem = 'residence'"
          :active="activeNavItem === 'residence'"
        >
          <q-item-section avatar>
            <q-icon name="maps_home_work" />
          </q-item-section>

          <q-item-section>
            Residence
          </q-item-section>
        </q-item>
        <q-item
          clickable
          v-ripple
          @click="activeNavItem = 'roommates'"
          :active="activeNavItem === 'roommates'"
        >
          <q-item-section avatar>
            <q-icon name="people" />
          </q-item-section>

          <q-item-section>
            Roommates
          </q-item-section>
        </q-item>

        <q-item
          clickable
          v-ripple
          @click="activeNavItem = 'vehicle'"
          :active="activeNavItem === 'vehicle'"
        >
          <q-item-section avatar>
            <q-icon name="directions_car" />
          </q-item-section>

          <q-item-section>
            Vehicle
          </q-item-section>
        </q-item>
        <q-item
          clickable
          v-ripple
          @click="activeNavItem = 'account'"
          :active="activeNavItem === 'account'"
        >
          <q-item-section avatar>
            <q-icon name="account_circle" />
          </q-item-section>

          <q-item-section>
            Account
          </q-item-section>
        </q-item>
        <q-item
          clickable
          v-ripple
          @click="activeNavItem = 'proxies'"
          :active="activeNavItem === 'proxies'"
        >
          <q-item-section avatar>
            <q-icon name="groups" />
          </q-item-section>

          <q-item-section>
            Proxies
          </q-item-section>
        </q-item>
        <q-separator />
        <q-item
          clickable
          v-ripple
          @click="activeNavItem = 'all'"
          :active="activeNavItem === 'all'"
        >
          <q-item-section avatar>
            <q-icon name="description" />
          </q-item-section>
          <q-item-section>
            Show All
          </q-item-section>
        </q-item>

        <q-item clickable
                v-ripple
                @click="activeNavItem = 'manage'"
                :active="activeNavItem === 'manage'">
          <q-item-section avatar>
            <q-icon name="settings" />
          </q-item-section>
          <q-item-section>
            Manage Application
          </q-item-section>
        </q-item>

        <q-item
          v-if="hasRoles('R&D')"
          clickable
          v-ripple
          @click="exportlogs"
        >
          <q-item-section avatar>
            <q-icon name="archive" />
          </q-item-section>
          <q-item-section>
            Export Logs
          </q-item-section>
        </q-item>
      </q-list>
    </q-drawer>

    <div class="mx-12">
      <div class="text-h4 font-bold text-left pb-2 mt-2">
        {{ sessionName }}
      </div>
      <hr class="border-t border-gray-600 my-4" />
    </div>
    <q-form
      ref="studentForm"
      greedy
    >
      <div
        v-for="application in studentsApplications"
        :key="application.applicationId"
        class="row"
      >
        <div v-if="application.sessionId === sessionIdSelected">
          <div class="bg-grey-1 q-pt-xs">
            <div
              v-if="activeNavItem === 'summary' || activeNavItem === 'all'"
              class="q-ma-md"
            >
              <div class="row">
                <div class="text-left text-h5 q-mt-xs">
                  General Information
                </div>
                <q-space />
                <div class="text-right">
                  <q-btn v-if="!hasPassedDeadline"
                         flat
                         :ripple="false"
                         color="primary"
                         label="Edit"
                         @click="isEditModalActive = true;
                          updateApplicationState(application.applicationId)"
                         no-caps />
                  <q-btn flat
                         :ripple="false"
                         color="primary"
                         label="Manage"
                         @click="activeNavItem = 'manage'"
                         no-caps />
                </div>
              </div>
              <q-separator />
              <div class="row items-start">
                <q-input
                  label="Application Status:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  borderless
                  readonly
                  :label="application.status"
                  label-color="black"
                  style="width: 300px"
                />
              </div>
              <div
                v-if="sessionDetails.depositAmount !== 0"
                class="row items-start"
              >
                <q-input
                  label="Deposit:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-if="application.deposit === 'Received' || application.deposit === 'Returned'"
                  style="width: 200px"
                  borderless
                  readonly
                  label="Completed"
                  label-color="black"
                />
                <router-link
                  v-else
                  :to="{
                    name: 'DepositPayment',
                    params: { applicationId: application.applicationId
                  }}"
                  class="q-mt-md"
                > Not Paid, Complete Deposit
                </router-link>
              </div>
              <div
                v-if="!!sessionDetails.dssUri"
                class="row items-start"
              >
                <q-input
                  label="DSS Accessibility Request:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-if="application.dssAccessible === 'Approved'"
                  :label="application.dssAccessible"
                  label-color="black"
                  borderless
                  readonly
                />
                <a
                  v-else
                  :href="sessionDetails.dssUri"
                  class="q-mt-md"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  {{ application.dssAccessible }}, Check or Update Request
                </a>
              </div>
              <div class="row items-start">
                <q-input
                  label="Vaccination Status:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  borderless
                  readonly
                  :label="user.vaccinationStatus"
                  label-color="black"
                />
                <q-btn
                  v-if="user.vaccinationStatus === null ||
                    user.vaccinationStatus === 'No Data' ||
                    user.vaccinationStatus === ''"
                  class="q-mt-sm"
                  @click="showAgreementModal = true"
                  color="white"
                  text-color="positive"
                  flat
                  icon="help_outline"
                  round
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Housing Agreement:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  :label="application.agreement ? 'Completed' : 'Pending'"
                  label-color="black"
                  borderless
                  readonly
                />
                <q-btn
                  v-if="!application.agreement"
                  class="q-mt-sm"
                  @click="showAgreementModal = true"
                  color="white"
                  text-color="positive"
                  flat
                  icon="help_outline"
                  round
                />
                <q-btn
                  v-if="sessionDetails.housingAgreementBlobId !== 0
                  && sessionDetails.housingAgreementBlobId !== null"
                  class="q-mt-sm"
                  @click="exportPdf(sessionDetails.housingAgreementBlobId, 'housingAgreement')"
                  color="white"
                  text-color="positive"
                  flat
                  icon="download"
                  round
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Residence Life Handbook:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  :label="application.handbookAgreement ? 'Completed' : 'Pending'"
                  label-color="black"
                  borderless
                  readonly
                />
                <q-btn
                  v-if="!application.handbookAgreement"
                  class="q-mt-sm"
                  @click="showAgreementModal = true"
                  color="white"
                  text-color="positive"
                  flat
                  icon="help_outline"
                  round
                />
                <q-btn
                  v-if="sessionDetails.handbookAgreementBlobId !== 0
                  && sessionDetails.handbookAgreementBlobId !== null"
                  class="q-mt-sm"
                  @click="exportPdf(
                  sessionDetails.handbookAgreementBlobId, 'residenceLifeHandbook')"
                  color="white"
                  text-color="positive"
                  flat
                  icon="download"
                  round
                />

              </div>

              <q-dialog
                ref="housingAgreementModal"
                v-model="showAgreementModal"
              >
                <q-card
                  align="left"
                  style="width: 550px; max-width: 80vw;"
                >
                  <div class="q-ma-lg">
                    Please note that the DigiPen Housing Agreement,
                    and Residence Life Handbook are not sent for signature
                    until placements (Housing Assignments) have occurred.
                    Please reference this date for your applied session on our website.
                    <a href="https://www.digipen.edu/campus-life/housing/apply-for-housing"
                    target="_blank">
                      https://www.digipen.edu/campus-life/housing/apply-for-housing
                    </a>
                  </div>
                  <div class="q-ma-lg">
                    Information on completion of these documents, and upload of
                    your vaccination documents will be contained in your placement email.
                    Please note that the status of completion shown here may take
                    1-3 business days to update after completing the documents.
                  </div>
                  <q-card-actions
                    align="center"
                    class="bg-white text-positive"
                  >
                    <q-btn
                      flat
                      label="Close"
                      v-close-popup
                    />
                  </q-card-actions>
                </q-card>
              </q-dialog>
              <q-dialog
                ref="handbookModal"
                v-model="showHandbookModal"
              >
                <q-card
                  align="left"
                  style="width: 550px; max-width: 80vw;"
                >
                  <q-btn
                    class="q-ma-md"
                    @click="exportPdf(
                    sessionDetails.handbookAgreementBlobId, 'residenceLifeHandbook')"
                    color="white"
                    text-color="positive"
                    flat
                    label="Download and view residence life handbook"
                    no-caps
                  />
                  <q-checkbox
                    class="q-px-md"
                    align="left"
                    v-model="application.handbookAgreement"
                    label="I have read, understand and agree to the terms and conditions
                    outlined in the Residence Life Handbook for this session.
                    Please check the checbox then confrim button below."
                    color="accent"
                  />
                  <q-card-actions
                    align="center"
                    class="bg-white text-positive"
                  >
                    <q-btn
                      flat
                      label="Cancel"
                      v-close-popup
                      color="primary"
                      @click="application.handbookAgreement = false"
                    />
                    <q-btn
                      @click="onUpdateAgreements(application)"
                      flat
                      label="Confirm"
                      :disable="!application.handbookAgreement"
                    />
                  </q-card-actions>
                </q-card>
              </q-dialog>
              <!-- <div class="row items-start">
                <q-input
                  label="Share email with roommates:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  :label="$filters.yesNo(application.shareEmail)"
                  label-color="black"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div> -->
              <div>
                <div
                  v-if="sessionDetails.sessionType === 'Academic'"
                  class="row items-start"
                >
                  <q-input
                    label="Graduating This Year:"
                    style="width: 250px"
                    borderless
                    readonly
                  />
                  <q-input
                    :label="application.graduatingThisYear"
                    label-color="black"
                    style="width: 300px"
                    borderless
                    readonly
                  />
                </div>
              </div>
            </div>

            <div
              v-if="activeNavItem === 'residence' || activeNavItem === 'all'"
              class="q-ma-md"
            >
              <div class="text-left text-h5 q-mt-xs">
                Residence Information
              </div>
              <q-separator />
              <div class="row items-start">
                <q-input
                  label="Building:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="placementDetails.complexName"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Building Address:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="placementDetails.fullAddress"
                  style="width: 500px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Unit:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="placementDetails.unitName"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="RA Name:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="placementDetails.raName"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="RA Email:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="placementDetails.raEmail"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Parking:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="placementDetails.parking"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="WiFi Name:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="placementDetails.wiFiName"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="WiFi Passowrd:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="placementDetails.wiFiPassword"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start"
                   v-if="isShadowbrookComplex(placementDetails.complexCode)
                      && isOnOrAfterMoveInDate">
                <q-input label="Mailbox Number:"
                         style="width: 250px"
                         borderless
                         readonly />
                <q-input v-model="placementDetails.mailboxNumber"
                         style="width: 300px"
                         borderless
                         readonly />
              </div>
              <div class="row items-start"
                   v-else-if="isShadowbrookComplex(placementDetails.complexCode)
                      && !isOnOrAfterMoveInDate">
                <q-input label="Mailbox Number:"
                         style="width: 250px"
                         borderless
                         readonly />
                <q-input :label="'Available on move in date: ' + sessionDetails.moveInDate"
                         style="width: 300px"
                         borderless
                         readonly />
              </div>
              <div
                class="row items-start"
                v-if="isOnOrAfterMoveInDate">
                <q-input
                  label="Door/Key Code:"
                  style="width: 250px"
                  borderless
                  readonly />
                <q-input
                  v-model="placementDetails.doorCode"
                  style="width: 300px"
                  borderless
                  readonly />
              </div>
              <div
                class="row items-start"
                v-else-if="!isOnOrAfterMoveInDate">
                <q-input
                  label="Door/Key Code:"
                  style="width: 250px"
                  borderless
                  readonly />
                <q-input
                  :label="'Available on move in date: ' + sessionDetails.moveInDate"
                  style="width: 300px"
                  borderless
                  readonly />
              </div>
              <template v-if="isOnOrAfterMoveInDate
                          && placementDetails.amenityCodes
                          && placementDetails.complexCode == 'SMT'">
                <div class="row items-start"
                     v-for="amenityCode, index in placementDetails.amenityCodes"
                     :key="index">
                  <q-input :label="amenityCode.name + ':'"
                           style="width: 250px"
                           borderless
                           readonly />
                  <q-input v-model="amenityCode.code"
                           style="width: 300px"
                           borderless
                           readonly />
                </div>
              </template>
              <div
                class="row items-start"
                v-else-if="!isOnOrAfterMoveInDate
                      && placementDetails.amenityCodes
                      && placementDetails.complexCode == 'SMT'"
              >
                <q-input
                  label="Amenity Codes:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  :label="'Available on move in date: ' + sessionDetails.moveInDate"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
            </div>

            <div
              v-if="activeNavItem === 'account' || activeNavItem === 'all'"
              class="q-ma-md"
            >
              <div class="row">
                <div class="text-left text-h5 q-mt-xs">
                  Student Information
                </div>
                <q-space />
                <div class="text-right">
                  <q-btn
                    v-if="!hasPassedDeadline"
                    flat
                    :ripple="false"
                    color="primary"
                    label="Edit"
                    @click="isEditModalActive = true;
                    updateApplicationState(application.applicationId)"
                    no-caps
                  />
                </div>
              </div>
              <q-separator />
              <div class="row items-start">
                <q-input
                  label="First Name:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.firstName"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Last Name:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.lastName"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Preferred First Name:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.preferredFirstName"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Mobile Phone:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.mobilePhone"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Permanent Phone:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.permanentPhone"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Digipen Email:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.digipenEmail"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Permanent Email:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.permanentEmail"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Date of Birth:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.dateOfBirth"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div
                v-if="(application.genderIdentity?.toLowerCase()?.trim() !== 'other'
                  || isEditing)"
                class="row items-start">
                <q-input
                  label="Gender Identity:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.genderIdentity"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div
                v-if="application.genderIdentity?.toLowerCase()?.trim() === 'other'"
                class="row items-start">
                <q-input
                  label="Gender Identity (Input):"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.genderIdentityOther"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Academic Year:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.academicYear"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row">
                <div class="text-left text-h5 q-mt-xs">
                  Address Information
                </div>
                <q-space />
                <div class="text-right">
                  <q-btn
                    v-if="!hasPassedDeadline"
                    flat
                    :ripple="false"
                    color="primary"
                    label="Edit"
                    @click="isEditModalActive = true;
                    updateApplicationState(application.applicationId)"
                    no-caps
                  />
                </div>
              </div>
              <q-separator />
              <div class="row items-start">
                <q-input
                  label="Permanent Address Line 1:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.permanentAddress"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Permanent Address Line 2:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.permanentAddress2"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="City:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.city"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Postal/Zip Code:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.zip"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Country/Region:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.country"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="State/Province:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.state"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row">
                <div class="text-left text-h5">
                  Emergency Contact Information
                </div>
                <q-space />

                <div>
                  <q-btn
                    v-if="isEditing"
                    flat
                    color="primary"
                    label="Save"
                    @click="onUpdateEmergencyContact(application);
                    isEditing = false"
                    no-caps
                  />
                  <q-btn
                    flat
                    :ripple="false"
                    color="primary"
                    label="Edit"
                    @click="hasPassedDeadline ? isEditing = !isEditing :
                    (
                      isEditModalActive = true,
                      updateApplicationState(application.applicationId)
                    )"
                    no-caps
                  />
                </div>
              </div>
              <q-separator />
              <div class="row items-start">
                <div
                  v-if="isEditing"
                  class="text-caption q-mt-xs text-left col-10"
                  style="max-width: 480px"
                >
                  <b>NOTE:</b> Changes made here will not reflect in your Colleague account.
                  To make changes, please visit Colleague Self-Service.
                </div>
              </div>
              <div class="row items-start">
                <q-input
                  label="Emergency Contact Name:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.emergencyContactName"
                  style="width: 300px"
                  :borderless="!isEditing"
                  :readonly="!isEditing"
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Emergency Contact Relation:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.emergencyContactRelation"
                  style="width: 300px"
                  :borderless="!isEditing"
                  :readonly="!isEditing"
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Emergency Contact Phone:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.emergencyContactPhone"
                  style="width: 300px"
                  :borderless="!isEditing"
                  :readonly="!isEditing"
                  :rules="[checkIsValidPhoneOrEmpty]"
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Emergency Contact Email:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.emergencyContactEmail"
                  style="width: 300px"
                  :borderless="!isEditing"
                  :readonly="!isEditing"
                  :rules="[checkIsValidEmailOrEmpty]"
                />
              </div>
            </div>

            <div
              v-if="activeNavItem === 'residence' ||
                activeNavItem === 'roommates' ||
                activeNavItem === 'all'"
              class="q-ma-md"
            >
              <div
                v-if="placementDetails.placementModels"
                class="text-left text-h5 q-mt-xs"
              >
                Roommate Placements
                <q-separator />
              </div>
              <div
                v-for="pm, i in placementDetails.placementModels"
                :key="pm"
              >
                <div
                  v-if="pm.placementStatus === 'Placed'"
                  class="row items-start"
                >
                  <q-input
                    :label="'Roommate ' + (i + 1) + ':'"
                    style="width: 100px"
                    borderless
                    readonly
                  />
                  <q-input
                    :label="pm.fullName"
                    label-color="black"
                    style="width: 250px"
                    borderless
                    readonly
                  />
                  <q-input
                    :label="pm.username + '@digipen.edu'"
                    label-color="black"
                    style="width: 300px"
                    borderless
                    readonly
                  />
                  <q-input
                    :label="computeRoomType(pm.roomName)"
                    label-color="black"
                    style="width: 250px"
                    borderless
                    readonly
                  />
                  <q-input
                    v-if="pm.roomRateTable"
                    :label="pm.roomRateTable"
                    label-color="black"
                    style="width: 300px"
                    borderless
                    readonly
                  />
                </div>
              </div>
            </div>
            <div
              v-if="activeNavItem === 'roommates' || activeNavItem === 'all'"
              class="q-ma-md"
            >
              <div class="row">
                <div class="text-left text-h5 q-mt-xs">
                  Roommate Preferences
                </div>
                <q-space />
                <div class="text-right">
                  <q-btn
                    v-if="!hasPassedDeadline"
                    flat
                    :ripple="false"
                    color="primary"
                    label="Edit"
                    @click="isEditModalActive = true;
                    updateApplicationState(application.applicationId)"
                    no-caps
                  />
                </div>
              </div>
              <q-separator />
              <div class="row items-start">
                <q-input
                  label="Gender Inclusive Housing:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  :label="application.liveWithSameGenders"
                  label-color="black"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div
                v-if="application.liveWithSameGenders == 'Other'"
                class="row items-start"
              >
                <q-input
                  label="Selected Roommates Gender Identities:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-select
                  v-model="application.roommatesGenders"
                  multiple
                  readonly
                  borderless
                  hide-dropdown-icon
                >
                </q-select>
              </div>

              <div class="row items-start">
                <q-input
                  label="Living Learning Community (Rainbow):"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-field
                  :label="application.livingLearningCommunityStatus"
                  label-color="black"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>

              <div class="row items-start">
                <q-input
                  label="Roommates Have Same Degree:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-field
                  :label="$filters.yesNo(application.roommatesHaveSameDegree)"
                  label-color="black"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>

              <div class="row items-start">
                <q-input
                  label="Roommates Have ESA:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-field
                  :label="$filters.yesNo(application.roommatesHaveEmotionalSupportAnimal)"
                  label-color="black"
                  style="width: 300px"
                  borderless
                  readonly
                />
                <q-icon
                  class="cursor-pointer q-mt-md"
                  color="positive"
                  size="sm"
                  name="help_outline"
                >
                  <q-tooltip
                    class="text-body2"
                    max-width="377px"
                    anchor="top middle"
                    self="bottom middle"
                    :offset="[10, 10]">
                    <div class="q-ma-sm">
                      Emotional Support Animal (ESA) or Service Animal
                    </div>
                  </q-tooltip>
                </q-icon>
              </div>
              <div class="row items-start">
                <q-input
                  label="Apartment Preference 1:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.apartmentPreference1"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Apartment Preference 2:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.apartmentPreference2"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Roommate 1 DigiPen Email:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.preferredRoommateDigipenEmail1"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Roommate 2 DigiPen Email:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.preferredRoommateDigipenEmail2"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Roommate 3 DigiPen Email:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.preferredRoommateDigipenEmail3"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Roommate 4 DigiPen Email:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.preferredRoommateDigipenEmail4"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
            </div>

            <div
              v-if="activeNavItem === 'vehicle' || activeNavItem === 'all'"
              class="q-ma-md"
            >
              <div class="row">
                <div class="text-left text-h5 q-mt-xs">
                  Vehicle Information
                </div>
                <q-space />
                <div class="text-right">
                  <q-btn
                    v-if="isEditing && hasPassedDeadline"
                    flat
                    color="primary"
                    label="Save"
                    @click="onUpdateVehicleInformation(application);
                    isEditing = false"
                    no-caps
                  />
                  <q-btn
                    flat
                    :ripple="false"
                    color="primary"
                    label="Edit"
                    @click="hasPassedDeadline ? isEditing = !isEditing :
                    (
                      isEditModalActive = true,
                      updateApplicationState(application.applicationId)
                    )"
                    no-caps
                  />
                </div>
              </div>
              <q-separator />
              <div class="row items-start">
                <div
                  v-if="isEditing"
                  class="text-caption q-mt-xs text-left col-10"
                  style="max-width: 480px"
                >
                  <b>NOTE:</b> Changes made here will not reflect in your Colleague account.
                  To make changes, please visit Colleague Self-Service.
                </div>
              </div>
              <div class="row items-start">
                <q-input
                  label="Vehicle Make:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.vehicleMake"
                  style="width: 300px"
                  :borderless="!isEditing"
                  :readonly="!isEditing"
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Vehicle Model:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.vehicleModel"
                  style="width: 300px"
                  :borderless="!isEditing"
                  :readonly="!isEditing"
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Vehicle License:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.vehicleLicense"
                  style="width: 300px"
                  :borderless="!isEditing"
                  :readonly="!isEditing"
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Vehicle Color:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="application.vehicleColor"
                  style="width: 300px"
                  :borderless="!isEditing"
                  :readonly="!isEditing"
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Issuing State:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-select
                  v-model="application.vehicleState"
                  style="width: 300px"
                  :borderless="!isEditing"
                  :readonly="!isEditing"
                  :options="statesOptions"
                  :hide-dropdown-icon="!isEditing"
                />
              </div>
              <div class="row items-start">
                <q-input
                  label="Parking:"
                  style="width: 250px"
                  borderless
                  readonly
                />
                <q-input
                  v-model="placementDetails.parking"
                  style="width: 300px"
                  borderless
                  readonly
                />
              </div>
            </div>

            <div
              v-if="(activeNavItem === 'all' || activeNavItem === 'proxies')"
              class="q-ma-md"
              >
               <div class="row">
                <div class="text-left text-h5 q-mt-xs">
                  Housing Proxies
                  <q-icon
                    class="cursor-pointer"
                    color="positive"
                    size="xs"
                    name="help_outline"
                  >
                    <q-tooltip
                      class="text-body2"
                      max-width="377px"
                      anchor="bottom middle"
                      self="bottom middle"
                      :offset="[-10, -10]">
                      <div class="q-ma-sm">
                        <div class="text-h6">What is a Housing Proxy?</div>
                        <div class="text-body2">
                          Under the protection of FERPA (Family Educational Rights and Privacy
                          Act of 1974), DigiPen Housing LLC will not release any information
                          pertaining to a student’s account or housing records to any family
                          member or personnel who may request information about an individual’s
                          record, unless permission to release this information is indicated by
                          the student. This proxy module is separate from
                          <i>Proxy module in Colleague Self-Service,</i>
                          which controls other records maintained by DigiPen
                          Institute of Technology.
                          <br />
                          <br />
                          A Housing Proxy is a person who can inquire, receive, and act on
                          information from DigiPen Housing on your behalf.
                          This person can be a parent, guardian, or other trusted individual;
                          <strong>however - students are not required to designate a proxy.</strong>
                          Examples of what a Housing Proxy can do: request edits to your application
                          profile, receive status updates on your application,
                          application requirements or placement, make payments and/or cancel or
                          terminate your application/contract.
                          <br />
                          <br />
                          Regardless of Proxy status, DigiPen Housing may
                          still require communication/confirmation
                          directly from the student in any of the above scenarios.
                        </div>
                      </div>
                    </q-tooltip>
                  </q-icon>
                </div>

                <q-space />
                <div class="text-right">
                  <q-btn
                    v-if="!isEditingProxy"
                    flat
                    :ripple="false"
                    color="positive"
                    label="Add Proxy"
                    @click="isProxyModalActive = true"
                    no-caps
                  />
                  <q-btn
                    v-if="userProxies.length != 0"
                    flat
                    :ripple="false"
                    color="primary"
                    label="Edit"
                    @click="isEditingProxy = !isEditingProxy"
                    no-caps
                  />
                  <q-btn
                    v-if="isEditingProxy"
                    flat
                    :ripple="false"
                    color="positive"
                    label="Save"
                    @click="isEditingProxy = false; onUpdateProxies()"
                    no-caps
                  />
                </div>
              </div>
              <q-separator />
              <div v-for="proxy in userProxies" :key="proxy?.userId">
                <HousingProxy
                  :isEditing="isEditingProxy"
                  :propProxyDetails="proxy"
                  :userId="userId" />
                <q-separator />
              </div>
            </div>

            <div
              v-if="activeNavItem === 'all'"
              class="q-ma-md"
            >
              <div>
                <div class="row">
                  <div class="text-left text-h5 q-mt-xs">
                    Tendencies
                  </div>
                  <q-space />
                  <div class="text-right">
                    <q-btn
                      v-if="!hasPassedDeadline"
                      flat
                      :ripple="false"
                      color="primary"
                      label="Edit"
                      @click="isEditModalActive = true;
                      updateApplicationState(application.applicationId)"
                      no-caps
                    />
                  </div>
                </div>
                <q-separator />

                <div class="row items-start">
                  <q-input
                    label="I would identify with having 'good' cleanliness habits."
                    style="width: 450px"
                    borderless
                    readonly
                  />
                  <q-input
                    :label="$filters.yesNo(application.cleanlinessHabits)"
                    label-color="black"
                    style="width: 100px"
                    borderless
                    readonly
                  />
                </div>
                <div class="row items-start">
                  <q-input
                    label="I would be open to sharing items in the apartment."
                    style="width: 450px"
                    borderless
                    readonly
                  />
                  <q-input
                    :label="$filters.yesNo(application.sharingHabits)"
                    label-color="black"
                    style="width: 100px"
                    borderless
                    readonly
                  />
                </div>
                <div class="row items-start">
                  <q-input
                    label="I would consider myself a social person."
                    style="width: 450px"
                    borderless
                    readonly
                  />
                  <q-input
                    :label="$filters.yesNo(application.socialHabits)"
                    label-color="black"
                    style="width: 100px"
                    borderless
                    readonly
                  />
                </div>
                <div class="row items-start">
                  <q-input
                    label="I have Pet Dander Allergies, or am allergic to a specific type of Pet."
                    style="width: 450px"
                    borderless
                    readonly
                  />
                  <q-input
                    :label="$filters.yesNo(application.hasPetAllergies)"
                    label-color="black"
                    style="width: 100px"
                    borderless
                    readonly
                  />
                </div>
                <div class="row items-start">
                  <q-input
                    label="I would consider myself a “morning person” and up early."
                    style="width: 450px"
                    borderless
                    readonly
                  />
                  <q-input
                    :label="$filters.yesNo(application.isMorningPerson)"
                    label-color="black"
                    style="width: 100px"
                    borderless
                    readonly
                  />
                </div>
                <div class="row items-start">
                  <q-input
                    label="I would consider myself a “night owl” and am often up later."
                    style="width: 450px"
                    borderless
                    readonly
                  />
                  <q-input
                    :label="$filters.yesNo(application.isNightPerson)"
                    label-color="black"
                    style="width: 100px"
                    borderless
                    readonly
                  />
                </div>
              </div>
            </div>

            <div v-if="activeNavItem === 'manage'"
                 class="q-ma-md">
              <div class="row">
                <div class="text-left text-h5 q-mt-xs">
                  Manage Application
                </div>
                <q-space />
                <div class="text-right">
                  <template v-if="allowCancelApplication
                            && applicationStatusAllowsCancel(application.status)
                            && allowApplicationManagementRequestCancel(
                              application.latestApplicationManagementRequestType)">
                    <q-btn flat
                           :ripple="false"
                           color="primary"
                           label="Cancel"
                           @click="cancelApplicationDialog(application)"
                           no-caps />

                    <q-icon class="cursor-pointer"
                            color="primary"
                            size="xs"
                            name="help_outline">
                      <q-tooltip class="text-body2"
                                 max-width="377px"
                                 anchor="bottom middle"
                                 self="bottom middle"
                                 :offset="[-10, -10]">
                        <div class="q-ma-sm">
                          <div class="text-h6">Cancel</div>
                          <div class="text-body2">
                            Should you want to Cancel your application with DigiPen Housing and
                            Residence Life for the upcoming Housing Session, please indicate so
                            through the menu. Should you choose to Cancel, policies are detailed
                            in our
                            <a href="https://www.digipen.edu/campus-life/housing/residential-life"
                               target="_blank">Housing Agreement(s).</a>
                            <br />
                            <br />
                            If you have chosen to Cancel, more information on your next steps, if
                            necessary, will be sent to your DigiPen email. Questions? Email
                            <a href="mailto:housing@digipen.edu">housing@digipen.edu</a>
                          </div>
                        </div>
                      </q-tooltip>
                    </q-icon>
                  </template>
                  <template v-else-if="application.status == 'Placed'
                            && !isAfterMoveInDate
                            && allowApplicationManagementRequestPlacement(
                              application.latestApplicationManagementRequestType)">
                    <q-btn-dropdown color="primary"
                                    label="Accept / Deny"
                                    flat
                                    no-caps>
                      <q-list>
                        <q-item clickable
                                v-close-popup
                                @click="acceptApplicationDialog(application)">
                          <q-item-section>
                            <q-item-label>
                              Accept Placement
                            </q-item-label>
                          </q-item-section>
                        </q-item>

                        <q-item clickable
                                v-close-popup
                                @click="
                                acceptWithReplacementApplicationDialog(application)">
                          <q-item-section>
                            <q-item-label>
                              Accept Placement, Request Waitlist - Placement Adjustment
                            </q-item-label>
                          </q-item-section>
                        </q-item>

                        <q-item clickable
                                v-close-popup
                                @click="denyApplicationDialog(application)">
                          <q-item-section>
                            <q-item-label>
                              Deny Placement, Cancel Application
                            </q-item-label>
                          </q-item-section>
                        </q-item>

                        <q-item clickable
                                v-close-popup
                                @click="
                                denyWithReplacementApplicationDialog(application)">
                          <q-item-section>
                            <q-item-label>
                              Deny Placement, Request Waitlist - New Placement
                            </q-item-label>
                          </q-item-section>
                        </q-item>
                      </q-list>
                    </q-btn-dropdown>

                    <q-icon class="cursor-pointer"
                            color="primary"
                            size="xs"
                            name="help_outline">
                      <q-tooltip class="text-body2"
                                 max-width="377px"
                                 anchor="bottom middle"
                                 self="bottom middle"
                                 :offset="[-10, -10]">
                        <div class="q-ma-sm">
                          <div class="text-h6">Accept/Deny</div>
                          <div class="text-body2">
                            DigiPen Housing and Residence Life have offered a placement within
                            our program for the upcoming Housing Session. Applicant must choose
                            between one of the following responses regarding their placement
                            offer by the communicated deadline. Details regarding each option
                            and corresponding deadline are outlined in the applicant’s placement
                            email. Should you choose to Cancel, policies are detailed in our
                            <a href="https://www.digipen.edu/campus-life/housing/residential-life"
                               target="_blank">Housing Agreement(s).</a>
                            <br />
                            <br />
                            After choosing an option, more information on your next steps, if
                            necessary, will be sent to your DigiPen email. Questions? Email
                            <a href="mailto:housing@digipen.edu">housing@digipen.edu</a>
                          </div>
                        </div>
                      </q-tooltip>
                    </q-icon>
                  </template>
                  <template v-else-if="application.status == 'Placed'
                            && isAfterMoveInDate
                            && allowApplicationManagementRequestTerminateContract(
                              application.latestApplicationManagementRequestType)">
                    <q-btn flat
                           :ripple="false"
                           color="primary"
                           label="Terminate Contract"
                           @click="terminateHousingApplicationDialog(application)"
                           no-caps />

                    <q-icon class="cursor-pointer"
                            color="primary"
                            size="xs"
                            name="help_outline">
                      <q-tooltip class="text-body2"
                                 max-width="377px"
                                 anchor="bottom middle"
                                 self="bottom middle"
                                 :offset="[-10, -10]">
                        <div class="q-ma-sm">
                          <div class="text-h6">Terminate</div>
                          <div class="text-body2">
                            Should you want to terminate your agreement/contract with DigiPen
                            Housing and Residence Life for the current Housing Session, please
                            indicate so through the menu and provide your reasoning/details for
                            your request. Please include: desired termination date and reason.
                            Policies regarding Agreement Termination are detailed in our
                            <a href="https://www.digipen.edu/campus-life/housing/residential-life"
                               target="_blank">Housing Agreement(s).</a>
                            <br />
                            <br />
                            Upon completion of this request, DigiPen Housing and Residence Life
                            will communicate your next steps, if necessary to your DigiPen Email.
                            Questions? Email
                            <a href="mailto:housing@digipen.edu">housing@digipen.edu</a>
                          </div>
                        </div>
                      </q-tooltip>
                    </q-icon>
                  </template>
                </div>
              </div>
              <q-separator />
              <div class="row items-start">
                <div class="row items-center">
                  <q-input label="Application Status:"
                           style="width: 250px"
                           borderless
                           readonly />
                  <q-input borderless
                           readonly
                           :label="application.status"
                           label-color="black"
                           style="width: 300px" />
                </div>
              </div>
              <div class="row items-start"
                   v-if="application.latestApplicationManagementRequestType !== 'None'">
                <div class="row items-center">
                  <q-input label="Request Status:"
                           style="width: 250px"
                           borderless
                           readonly />
                  <q-input borderless
                           readonly
                           :label="formatApplicationManagementRequestStatus(
                            application.latestApplicationManagementRequestType,
                            false)"
                           label-color="black"
                           style="width: 300px" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </q-form>
    <div
      v-if="!appliedSessionsSet.has(sessionIdSelected)
      && isPlacedInPreviousSessionSet.has(sessionIdSelected)"
      class="row q-gutter-lg"
    >
      <div class="text-h5 text-left col-12">
       You do not have to apply to this session
       since you are a part of the Academic session already.
      </div>
    </div>
    <div
      v-else-if="!sessionIdSelected"
      class="row q-gutter-lg"
    >
      <div class="text-h5 text-left col-12">
        Please select a session.
      </div>
    </div>
    <div v-if="sessionIdSelected
      && !appliedSessionsSet.has(sessionIdSelected)"
      class="text-h5 text-left col-12">
      <q-btn
          :to="{ path: 'create-application', query: { source: 'landing' }}"
          label="Apply to Session"
          color="primary"
          no-caps
        />
      </div>
    <q-dialog
      ref="editModal"
      v-model="isEditModalActive"
    >
      <q-card style="width: 800px; max-width: 80vw;">
        <ApplicationDetailedSummary ref="applicationForm" />

        <q-card-actions
          align="center"
          class="bg-white text-teal"
        >
          <q-btn
            v-if="hasRoles('R&D', 'HRL') || !hasPassedDeadline"
            flat
            label="Save"
            @click="submitApplicationForm()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog
      ref="editProxyModal"
      v-model="isProxyModalActive"
    >
      <q-card style="width: 800px; max-width: 80vw;">
        <HousingProxy ref="proxyForm" :isAdding="true" :userId="userId" />
        <br />
        <q-card-actions
          align="center"
          class="bg-white text-teal q-pa-lg"
        >
          <q-btn
            flat
            color="primary"
            label="Cancel"
            @click="isProxyModalActive = false"
          />
          <q-btn
            color="positive"
            label="Save"
            @click="submitAddProxyForm()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useQuasar } from 'quasar';
import useApplication from '@/hooks/application';
import useSession from '@/hooks/session';
import useAuth from '@/hooks/auth';
import useUser from '@/hooks/user';

import filterSessionsByOIPStatus from '@/utilities/sessionFilterUtility';
import useUiUtilities from '@/utilities/uiUtilities';
import useFilter from '@/utilities/filters';
import useValidations from '@/utilities/uiValidations';
import usePlacement from '@/hooks/placement';
import useUtility from '@/hooks/utility';
import ApplicationDetailedSummary from '../ApplicationForm/ApplicationDetailedSummary.vue';
import HousingProxy from './HousingProxy.vue';
import ConfirmDialog from '../Dialogs/ConfirmDialog.vue';
import ConfirmPromptDialog from '../Dialogs/ConfirmPromptDialog.vue';

export default {
  async setup() {
    const $q = useQuasar();
    const { user, hasRoles } = useAuth();
    const userHook = useUser();
    const {
      currentApplicationId,
      studentsApplications,
      getApplicationsByUserId,
      updateAgreements,
      updateEmergencyContact,
      updateVehicleInformation,
      submitApplicationManagementRequest,
    } = useApplication();
    const {
      fetchSession,
      fetchSessionNameIds,
      getIsPlacedInPreviousSession,
      sessionDetails,
      sessionIdSelected,
    } = useSession();
    const { getUnitPlacement, placementDetails } = usePlacement();
    const { getUserProxies, addOrUpdateUserProxies } = useUser();

    const {
      createDownloadableFile,
      exportPdf,
      hasPassedAppilcationDeadline,
      notifyResult,
      statesOptions,
      isDateBeforeCurrentDate,
      isDateAfterCurrentDate,
      formatApplicationManagementRequestStatus,
      isShadowbrookComplex,
      isSummitComplex,
    } = useUiUtilities();
    const { sessionNameIdsFilteredByRole } = useFilter();
    const { checkIsValidPhoneOrEmpty, checkIsValidEmailOrEmpty } = useValidations();
    const { getLoggingExport } = useUtility();

    const studentForm = ref(null);
    const activeStudentSession = ref([]);
    const applicationForm = ref();
    const proxyForm = ref();
    const appliedSessionsSet = new Set();
    const activeNavItem = ref('summary');
    const editModal = ref(null);
    const editProxyModal = ref(null);
    const handbookModal = ref(null);
    const housingAgreementModal = ref(null);
    const isEditing = ref(false);
    const hasPassedDeadline = ref(true);
    const sessionName = ref('');
    const currentDate = new Date()
      .toLocaleDateString(
        undefined,
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        },
      );
    const selectedApplicationId = ref();
    const isPlacedInPreviousSessionSet = new Set();

    // we only allow cancelling applications after the
    // current session's start date and prior to placement
    const allowCancelApplication = computed(
      () => isDateAfterCurrentDate(sessionDetails.value.startDate)
        && placementDetails.value.placementModels === null,
    );

    const applicationStatusAllowsCancel = (applicationStatus) => [
      'Submitted',
      'Accepted',
      'Placed',
    ].includes(applicationStatus);

    const allowApplicationManagementRequestCancel = (requestTypeName) => requestTypeName !== 'Cancel Application';

    const allowApplicationManagementRequestPlacement = (requestTypeName) => [
      'Accept Placement',
      'Accept Placement - Request Waitlist',
      'Deny Placement',
      'Deny Placement - Request Waitlist',
    ].includes(requestTypeName) === false;

    const allowApplicationManagementRequestTerminateContract = (requestTypeName) => requestTypeName !== 'Terminate Contract';

    const isAfterMoveInDate = computed(
      () => isDateAfterCurrentDate(sessionDetails.value.moveInDate),
    );

    const isOnOrAfterMoveInDate = computed(
      () => !isDateBeforeCurrentDate(sessionDetails.value.moveInDate),
    );

    const hasPassedConfirmationDeadline = computed(
      () => isDateAfterCurrentDate(sessionDetails.value.confirmationDeadline),
    );

    const filterSessions = async () => {
      try {
        activeStudentSession.value = await filterSessionsByOIPStatus(
          activeStudentSession.value,
          user.value.username,
          user.value.colleagueId,
          {
            getOipStudents: userHook.getOipStudents,
            fetchSession,
          },
        );
      } catch (error) {
        console.error('Error filtering sessions:', error);
      }
    };
    await getApplicationsByUserId(user.value.userId);
    await fetchSessionNameIds(true);
    activeStudentSession.value = sessionNameIdsFilteredByRole.value.map(
      (item) => ({ label: item.sessionName, value: item.sessionId }),
    );
    const activeSessionNames = activeStudentSession.value.map(
      (item) => item.label,
    );
    await filterSessions();
    for (let i = 0; i < studentsApplications.value.length; i += 1) {
      appliedSessionsSet.add(studentsApplications.value[i].sessionId);
      if (!activeSessionNames.includes(
        studentsApplications.value[i].sessionName,
      )) {
        activeStudentSession.value.unshift({
          label: studentsApplications.value[i].sessionName,
          value: studentsApplications.value[i].sessionId,
        });
      }
    }
    for (let i = 0; i < sessionNameIdsFilteredByRole.value.length; i += 1) {
      if (activeSessionNames.includes(sessionNameIdsFilteredByRole.value[i].sessionName)) {
        // track if student is placed in previous session
        if (await getIsPlacedInPreviousSession(sessionNameIdsFilteredByRole.value[i].sessionId)) { // eslint-disable-line
          isPlacedInPreviousSessionSet.add(sessionNameIdsFilteredByRole.value[i].sessionName);
        }
      }
    }

    const onUpdateAgreements = async (updateApplication) => {
      $q.loading.show();
      const result = await updateAgreements(updateApplication);
      notifyResult(result.status, result);
      if (result.status === 200 || result.status === 201) {
        handbookModal.value.hide();
        housingAgreementModal.value.hide();
      }
      $q.loading.hide();
    };

    const onUpdateEmergencyContact = async (updateApplication) => {
      $q.loading.show();
      const result = await studentForm.value.validate();
      if (result) {
        const response = await updateEmergencyContact(updateApplication);
        notifyResult(response.status, response);
        isEditing.value = false;
      }
      $q.loading.hide();
    };

    const onUpdateVehicleInformation = async (updateApplication) => {
      $q.loading.show();
      const response = await updateVehicleInformation(updateApplication);
      notifyResult(response.status, response);
      $q.loading.hide();
    };

    const onSelectedSessionUpdate = async (localSessionId) => {
      sessionName.value = activeStudentSession.value.find(
        (session) => session.value === localSessionId,
      )?.label;
      if (appliedSessionsSet.has(localSessionId)) {
        await fetchSession(localSessionId, true);
        hasPassedDeadline.value = hasPassedAppilcationDeadline();
        await getUnitPlacement(sessionDetails.value.sessionId, user.value.userId);
      }
    };

    const updateApplicationState = (updateApplicationId) => {
      currentApplicationId.value = updateApplicationId;
      selectedApplicationId.value = updateApplicationId;
    };

    const submitApplicationForm = async () => {
      $q.loading.show();
      const response = await applicationForm.value.onSubmit();
      if (response === 200 || response === 201) {
        editModal.value.hide();
        await getApplicationsByUserId(user.value.userId); // @TODO: optimize
      }

      $q.loading.hide();
    };

    const submitAddProxyForm = async () => {
      $q.loading.show();
      const response = await proxyForm.value.onSubmit();
      if (response === 200 || response === 201) {
        editProxyModal.value.hide();
      }

      $q.loading.hide();
      window.location.reload();
    };

    const exportlogs = async () => {
      try {
        $q.loading.show();
        const result = await getLoggingExport();
        createDownloadableFile(result, 'logs_export.csv', 'text/csv;charset=utf-8;');
        $q.loading.hide();
      } catch (error) {
        console.log(error);
      }
    };

    const computeRoomType = (roomName) => {
      const lastTowChars = roomName.slice(-2);
      let result = '';
      if (lastTowChars === 'NM') {
        result = `${roomName} (Non-Master Bedroom)`;
      } else if (lastTowChars.slice(-1) === 'M') {
        result = `${roomName} (Master Bedroom)`;
      } else {
        result = `${roomName} (Single Bedroom)`;
      }

      return result;
    };

    await onSelectedSessionUpdate(sessionIdSelected.value);
    await getUnitPlacement(sessionIdSelected.value, user.value.userId);
    const userProxies = await getUserProxies(user.value.userId);

    const onUpdateProxies = async () => {
      $q.loading.show();
      const result = await addOrUpdateUserProxies(userProxies); // submit all proxy list as update
      notifyResult(result.status, result);
      $q.loading.hide();
    };

    function sendApplicationManagementRequestFn(
      application,
      requestType,
      requestTypeName,
    ) {
      const data = {
        ApplicationId: application.applicationId,
        RequestType: requestType,
      };

      return (reason) => {
        if (reason.value !== undefined) {
          data.Reason = reason.value;
        }

        submitApplicationManagementRequest(data)
          .then((response) => {
            if (response != null && response.status === 200) {
              // eslint-disable-next-line no-param-reassign
              application.latestApplicationManagementRequestType = requestTypeName;
            }
          });
      };
    }

    const cancelApplicationDialog = (application) => {
      $q.dialog({
        component: ConfirmDialog,
        componentProps: {
          cancelLabel: 'No',
          title: 'Cancel Application',
          body: 'Are you sure you want to cancel your housing application?',
        },
      }).onOk(sendApplicationManagementRequestFn(
        application,
        5,
        'CancelApplication',
      )).onCancel(() => {
        // TODO(bryant): this might not be needed, clean up after plugging in functionality
      });
    };

    const acceptApplicationDialog = (application) => {
      $q.dialog({
        component: ConfirmDialog,
        componentProps: {
          title: 'Accept Placement',
          body: 'Are you sure you want to accept your housing application?',
        },
      }).onOk(sendApplicationManagementRequestFn(
        application,
        1,
        'AcceptPlacement',
      )).onCancel(() => {
        // TODO(bryant): this might not be needed, clean up after plugging in functionality
      });
    };

    const denyApplicationDialog = (application) => {
      $q.dialog({
        component: ConfirmDialog,
        componentProps: {
          // TODO(bryant): find desired text for the deny application dialog
          title: 'Deny Placement, Cancel Application',
          body: 'Are you sure you want to deny your housing application?',
        },
      }).onOk(sendApplicationManagementRequestFn(
        application,
        3,
        'DenyPlacement',
      )).onCancel(() => {
        // TODO(bryant): this might not be needed, clean up after plugging in functionality
      });
    };

    const acceptWithReplacementApplicationDialog = (application) => {
      $q.dialog({
        component: ConfirmPromptDialog,
        componentProps: {
          title: 'Accept Placement, Request Waitlist - Placement Adjustment',
          body: 'Please detail your reason to request placement adjustment, including but not limited to: room type, roommates, or other placement factors',
          style: 'width: 800px; max-width: 80vw;',
          promptLabel: 'Reason *',
          maxLength: 500,
          counter: true,
        },
      }).onOk(sendApplicationManagementRequestFn(
        application,
        2,
        'AcceptPlacementRequestWaitlist',
      )).onCancel(() => {
        // TODO(bryant): this might not be needed, clean up after plugging in functionality
      });
    };

    const denyWithReplacementApplicationDialog = (application) => {
      $q.dialog({
        component: ConfirmPromptDialog,
        componentProps: {
          title: 'Deny Placement, Request Waitlist - New Placement',
          body: 'Please detail your reason for your denial of placement, and a reason for request of new placement',
          style: 'width: 800px; max-width: 80vw;',
          promptLabel: 'Reason *',
          maxLength: 500,
          counter: true,
        },
      }).onOk(sendApplicationManagementRequestFn(
        application,
        4,
        'DenyPlacementRequestWaitlist',
      )).onCancel(() => {
        // TODO(bryant): this might not be needed, clean up after plugging in functionality
      });
    };

    const terminateHousingApplicationDialog = (application) => {
      $q.dialog({
        component: ConfirmPromptDialog,
        componentProps: {
          // TODO(bryant): find desired text for the terminate housing contract dialog
          title: 'Terminate Housing Contract Request',
          body: 'Please detail your reason for terminating the housing contract',
          style: 'width: 800px; max-width: 80vw;',
          promptLabel: 'Reason *',
          maxLength: 500,
          counter: true,
        },
      }).onOk(sendApplicationManagementRequestFn(
        application,
        6,
        'TerminateContract',
      )).onCancel(() => {
        // TODO(bryant): this might not be needed, clean up after plugging in functionality
      });
    };

    return {
      applicationForm,
      appliedSessionsSet,
      activeStudentSession,
      checkIsValidEmailOrEmpty,
      checkIsValidPhoneOrEmpty,
      computeRoomType,
      currentDate,
      editModal,
      editProxyModal,
      exportlogs,
      exportPdf,
      getIsPlacedInPreviousSession,
      handbookModal,
      hasPassedDeadline,
      housingAgreementModal,
      isEditing,
      isEditingProxy: ref(false),
      isEditModalActive: ref(false),
      isProxyModalActive: ref(false),
      isPlacedInPreviousSessionSet,
      onSelectedSessionUpdate,
      onUpdateProxies,
      placementDetails,
      proxyForm,
      sessionDetails,
      sessionIdSelected,
      showHandbookModal: ref(false),
      showAgreementModal: ref(false),
      statesOptions,
      studentsApplications,
      studentForm,
      submitApplicationForm,
      submitAddProxyForm,
      drawer: ref(),
      activeNavItem,
      onUpdateAgreements,
      onUpdateEmergencyContact,
      onUpdateVehicleInformation,
      sessionNameIdsFilteredByRole,
      hasRoles,
      updateApplicationState,
      user,
      userProxies,
      sessionName,
      userId: user.value.userId,
      allowCancelApplication,
      applicationStatusAllowsCancel,
      isAfterMoveInDate,
      isOnOrAfterMoveInDate,
      hasPassedConfirmationDeadline,
      cancelApplicationDialog,
      acceptApplicationDialog,
      denyApplicationDialog,
      acceptWithReplacementApplicationDialog,
      denyWithReplacementApplicationDialog,
      terminateHousingApplicationDialog,
      allowApplicationManagementRequestCancel,
      allowApplicationManagementRequestPlacement,
      allowApplicationManagementRequestTerminateContract,
      formatApplicationManagementRequestStatus,
      isShadowbrookComplex,
      isSummitComplex,
    };
  },
  components: {
    ApplicationDetailedSummary,
    HousingProxy,
  },
};
</script>

<style>
.q-field__label {
  font-size: 14px !important;
  opacity: 0.87 !important;
}
</style>
